import React, {useState} from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setFormData } from 'Services/Features/SetupSchedule/setupScheduleSlice';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';

const SetupForm = () => {
    const dispatch = useDispatch();
    const data = useSelector(state => state.setupSchedule.currentSetupSchedule);
    // Fungsi handleChange untuk semua input (termasuk DatePicker)
    const handleChange = (name, value) => {
        dispatch(setFormData({ [name]: value }));
    };

    return (
        <Row>
            <Col xs={12} sm={12} md={6}>
                <FormGroup>
                    <Label for="will_applied_at" className="d-block">Akan Berlaku Pada</Label>
                    <DatePicker
                        selected={data.will_applied_at ? new Date(data.will_applied_at) : null}
                        onChange={(date) => handleChange("will_applied_at", format(date, "yyyy-MM-dd"))}                        
                        dateFormat="yyyy-MM-dd"
                        className="form-control digits"
                        placeholderText="Pilih Tanggal"
                        minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                    />
                </FormGroup>
            </Col>
            <Col xs={12} sm={12} md={6}>
                <FormGroup>
                    <Label for="schedule_date" className="d-block">Tanggal Jadwal</Label>
                    <DatePicker
                        selected={data.schedule_date ? new Date(data.schedule_date) : null}
                        onChange={(date) => handleChange("schedule_date", format(date, "yyyy-MM-dd HH:mm:ss"))}
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="Waktu"
                        timeFormat="HH:mm"
                        className="form-control digits"
                        placeholderText="Pilih Tanggal"
                        minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                    />
                </FormGroup>
            </Col>
            <Col xs={12} sm={12} md={6}>
                <FormGroup>
                    <Label for="hour_start_at" className="d-block">Jam Mulai</Label>
                    <DatePicker
                        selected={data.hour_start_at ? new Date(`1970-01-01T${data.hour_start_at}`) : null}
                        onChange={(date) => handleChange("hour_start_at", format(date, "HH:mm"))}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Open"
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        className="form-control digits"
                        placeholderText="Pilih Jam Buka"
                    />
                </FormGroup>
            </Col>
            <Col xs={12} sm={12} md={6}>
                <FormGroup>
                    <Label for="hour_end_at" className="d-block">Jam Selesai</Label>
                    <DatePicker
                        selected={data.hour_end_at ? new Date(`1970-01-01T${data.hour_end_at}`) : null}
                        onChange={(date) => handleChange("hour_end_at", format(date, "HH:mm"))}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Open"
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        className="form-control digits"
                        placeholderText="Pilih Jam Tutup"
                    />
                </FormGroup>
            </Col>
            <Col xs={7} sm={7} md={6}>
                <FormGroup>
                    <Label for="quota">Kuota</Label>
                    <Input
                        type="number"
                        name="quota"
                        id="quota"
                        value={data.quota || ""}
                        min="1"
                        onKeyDown={(e) => {
                            if (["ArrowUp", "ArrowDown", "-", "e"].includes(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        onChange={(e) => handleChange(e.target.name, e.target.value)}
                    />
                </FormGroup>
            </Col>
        </Row>
    );
};

export default SetupForm;